import { render, staticRenderFns } from "./AppTopNavbar.vue?vue&type=template&id=468318a2&scoped=true&lang=pug&"
import script from "./AppTopNavbar.vue?vue&type=script&lang=ts&"
export * from "./AppTopNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppTopNavbar.vue?vue&type=style&index=0&id=468318a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468318a2",
  null
  
)

export default component.exports